<template>
  <portlet
    :icon="'fal fa-folder-open'"
    :title="'Afspraken'"
    :actionsBlock="true"
  >
    <template slot="portletBody">
      <div class="table-responsive vacancy-info">
        <table class="table dataTable table-bordered table-striped"
               v-if="getCandidateAppointments(candidateId).length !== 0">
          <thead>
          <tr>
            <th>Bedrijf</th>
            <th>Plaats</th>
            <th>E-mailadres</th>
            <th>Contactpersoon</th>
            <th>Datum afspraak</th>
            <th>Starttijd</th>
            <th>Eindtijd</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(appointment, index) in getCandidateAppointments(candidateId)" :key="appointment.index">
            <td v-if="getCustomer(appointment.customerId)">
              <router-link :to="'/customers/'+ appointment.customerId">
                {{getCustomerName(appointment.customerId)}}
              </router-link>
            </td>
            <td>{{getCustomerLocation(appointment.customerId)}}</td>
            <td><a :href="'mailto://' + appointment.email">{{appointment.email}}</a></td>
            <td>{{appointment.contact}}</td>
            <td>{{appointment.startDate|day}}</td>
            <td>{{ appointment.startTime}} </td>
            <td>{{appointment.endTime}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="getCandidateAppointments(candidateId).length === 0">
        Er zijn nog geen afspraken gepland.
      </div>
    </template>
  </portlet>
</template>


<script>
  import {mapGetters} from "vuex";

  export default {
    props: ["candidateId"],
    data() {
      return {};
    },
    methods: {
      getCustomerName(id) {
        return this.getCustomer(id).name;
      },

      getCustomerLocation(id) {
        return this.getCustomer(id).location;
      }
    },
    computed: {
      ...mapGetters("appointments", ["getCandidateAppointments"]),
      ...mapGetters("customers", ["getCustomer"]),
    },
  };
</script>
